<template>
    <div class="flex-con is-grow side-menu-layout-con no-middle-align">
        <div class="is-narrow side-menu" :class="cssClasses">
            <slot name="menu"></slot>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name : 'SideMenuLayout',
    props : {
        className : {
            required : false,
            type : String,
        },
        isDefault : {
            required : false,
            type : Boolean,
            default : true,
        },
    },
    computed : {
        cssClasses () {
            return {
                default : this.isDefault,
                [this.className] : this.className,
            };
        }
    }
}
</script>

<style lang="scss">

    @import '../assets/css/_theme.scss';

    .side-menu-layout-con {

        align-items:stretch;
        height:100%;

        & > div {
            height:100% !important;
        }

        .side-menu {
            min-width:170px;
            border-right:2px solid $white-ter;
            overflow-y:auto;
        }

        .default {
            background-color:$white-ter;
        }

        .filtering-menu-con {
            padding:15px 15px 20px 15px;

            .menu-list {
                font-size:12px;

                li {
                    cursor:pointer;
                    color:$gray5;
                    padding:2px;
                    border-radius:3px;
                    &:hover {
                        background-color:$grey-lighter;
                    }
                    h3 {
                        padding:3px;
                    }
                }

                .selection {
                    .fa {
                        color:$brandTeal;
                    }
                    border-radius: 4px 4px;
                }

                .fa.selected {
                    color:$primary;
                }

            }

            .menu-label {
                margin-bottom:4px;
            }

        }

        .layout-content {
            padding:15px;
            position:relative;
        }

        .basic-menu-con {
            & > .item {
                font-size:$size-5;
                border-bottom:1px solid $grey-lighter;
                a {
                    padding:6px 10px;
                    display:block;
                    color:$grey-dark;
                    &:hover {
                        background-color:$white-bis;
                        color:$grey-dark;
                        font-weight:bold;
                    }

                    &.router-link-exact-active {
                        background-color:$white-bis;
                        box-shadow:inset 0 0 3px -2px $brandOrange;
                        color:$grey-dark;
                        font-weight:bold;
                        border-left:4px solid $brandOrange;
                    }

                }

            }
        }

    }
</style>
